import { ModMapping } from "./ModulePermissionsMap";

export default function hasPermissions(moduleName) {
  const userData = localStorage.getItem('user');
  if (!userData) return {};
  // debugger

  const moduleId = ModMapping(moduleName);
  try {
    const user = JSON.parse(userData);

    // Ensure 'Permissions' is properly parsed
    const permissions = typeof user.Permissions === "string"
      ? JSON.parse(user.Permissions)
      : user.Permissions;

    
    // console.log("permissions",permissions);
    if (!Array.isArray(permissions)) return {};

    // Find the module
    const module = permissions.find(m => Number(m.ModuleId) === Number(moduleId));
    if (!module) return {};

    // console.log("module",module);

    // Return an object mapping permission IDs to boolean values
    return module.Permissions.reduce((acc, perm) => {
      if (perm?.PermissionId) acc[perm.PermissionId] = true;
      return acc;
    }, {});

  } catch (error) {
    console.error('Error parsing user permissions:', error);
    return {};
  }

}
